import styled from '@emotion/styled';
import { borderColor } from '../TableRowContainer/TableRowContainer.styled';
import { StyledProps, TableDataProps } from './TableDataContainer.types';

const TableData = styled.td<StyledProps & TableDataProps>`
  padding: ${(props) => (props.rowPadding ? props.rowPadding : '20px')};
  text-align: ${(props) => (props.centered ? 'center' : 'start')};
  border: ${(props) => props.bordered && `1px solid ${borderColor}`};
  width: ${(props) => (props.columnWidth ? `${props.columnWidth}%` : 'auto')};

  @media (max-width: 1520px) {
    padding: 12px;
  }

  @media (max-width: 1460px) {
    padding: 13px;
  }

  @media (max-width: 1200px) {
    padding: 7px;
  }
`;

export default TableData;
